export const formatedDate = (dateget: string) => {
  // Código da função aqui
  const date = new Date(dateget);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const formatedDateBr = (dateget: any) => {
  // Código da função aqui
  const date = new Date(dateget);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};

export const formatDateUs = (date: any) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateString = (date: string) => {
  const dateArray = date.split("-");
  if (dateArray.length === 3) {
    const year = parseInt(dateArray[0]);
    const month = parseInt(dateArray[1]) - 1;
    const day = parseInt(dateArray[2]);

    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      return new Date(year, month, day);
    }
  }
  return new Date();
};

export const toLocaleString3 = (str: any) => {
  return str
    ? str.toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    : str;
};
